export const SET_SELECTED_ARR = "SET_SELECTED_ARR";
export const CLEAR_SELECTED_ARR = "CLEAR_SELECTED_ARR";
